module.exports = __webpack_public_path__ + "img/face-laugh-beam.32da9ae7.svg";